import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, CreditCard } from 'lucide-react';
import { Countdown } from './Countdown';
import { CHECKOUT_LINKS } from '../config/checkout';
import { trackInitiateCheckout } from '../hooks/useMetaPixel';
export function Closing() {
  return <section className="py-20 md:py-32 bg-white relative overflow-hidden" data-id="element-10">
      {/* Subtle background texture */}
      <div className="absolute bottom-0 right-0 w-full max-w-2xl h-[400px] bg-ember/5 rounded-full blur-3xl -z-10 translate-x-1/3 translate-y-1/3" data-id="element-11" />

      <div className="max-w-4xl mx-auto px-4" data-id="element-12">
        {/* Cost Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-24" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-14">
            <span className="text-charcoal/30" data-id="element-15">⚖️</span> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>

          <div className="bg-cream rounded-2xl border border-sand shadow-sm overflow-hidden max-w-3xl mx-auto font-mono text-sm" data-id="element-16">
            <div className="overflow-x-auto scrollbar-hide" data-id="element-17">
              <table className="w-full text-left min-w-[500px]" data-id="element-18">
                <thead data-id="element-19">
                  <tr className="border-b border-sand/60" data-id="element-20">
                    <th className="p-4 md:p-6 font-bold text-charcoal/50 uppercase tracking-widest w-1/2" data-id="element-21">
                      Sin AirPack
                    </th>
                    <th className="p-4 md:p-6 font-bold text-charcoal/50 uppercase tracking-widest w-1/2" data-id="element-22">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-sand/40" data-id="element-23">
                  {[['Delivery 3 veces por semana', 'Hasta $180.000 ARS por mes'], ['Recetas que no funcionan', 'Ingredientes tirados'], ['Freidora guardada', 'El aparato que pagaste sin usar'], ['Sin sistema de meal prep', 'Decisión diaria que agota']].map((row, i) => <tr key={i} className="hover:bg-white/50 transition-colors" data-id="element-24">
                      <td className="p-4 md:p-6 text-charcoal/80" data-id="element-25">{row[0]}</td>
                      <td className="p-4 md:p-6 font-bold text-charcoal" data-id="element-26">
                        {row[1]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <p className="text-center text-xl md:text-2xl font-serif italic text-ember mt-12" data-id="element-27">
            La próxima semana puede ser completamente distinta. 🇦🇷🔥
          </p>
        </motion.div>

        {/* Final CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-charcoal rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-28">
          {/* Decorative subtle lines */}
          <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '24px 24px'
        }} data-id="element-29"></div>

          <div className="relative z-10" data-id="element-30">
            <div className="mb-12 space-y-4" data-id="element-31">
              <p className="text-2xl md:text-3xl font-serif italic text-white/90" data-id="element-32">
                Imaginá abrir tu Air Fryer mañana...
              </p>
              <p className="text-2xl md:text-3xl font-serif italic text-white/90" data-id="element-33">
                ...y ya saber exactamente qué cocinar.
              </p>
              <p className="text-lg text-white/60 font-medium pt-4" data-id="element-34">
                Sin delivery. Sin improvisar. Sin perder tiempo. Con todo
                resuelto.
              </p>
            </div>

            <div className="flex flex-col gap-4 max-w-xl mx-auto mb-10" data-id="element-35">
              <a href={CHECKOUT_LINKS.esencial} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout({
              plan: 'esencial',
              value: 19900
            })} className="w-full py-5 px-6 rounded-xl bg-ember hover:bg-ember-dark text-white font-bold transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg flex flex-col sm:flex-row items-center justify-center gap-3 group border border-ember-light/20 text-lg" data-id="element-36">
                <span className="text-2xl group-hover:translate-x-1 transition-transform" data-id="element-37">
                  👉
                </span>
                QUIERO RESOLVER MIS COMIDAS TODO EL AÑO
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs font-medium text-white/60" data-id="element-38">
              <span className="flex items-center gap-1" data-id="element-39">
                <Lock size={14} data-id="element-40" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-41">
                <span className="text-ember" data-id="element-42">⚡</span> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-43">
                <ShieldCheck size={14} data-id="element-44" /> Garantía 7 días
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-3 text-xs font-medium text-white/40 mt-4" data-id="element-45">
              <span className="flex items-center gap-1" data-id="element-46">
                <CreditCard size={14} data-id="element-47" /> Mercado Pago · Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="mt-24 border-t border-sand pt-8 pb-12 text-center" data-id="element-48">
        <div className="font-bold tracking-wide text-charcoal/80 mb-4" data-id="element-49">
          <span data-id="element-50">🇦🇷</span> AIRPACK™
        </div>
        <p className="text-xs text-charcoal/40" data-id="element-51">
          © {new Date().getFullYear()} AirPack. Todos los derechos reservados.
        </p>
      </footer>
    </section>;
}